import { baseApiSlice } from '../../commons/base-api.config';
import { HTTP_METHODS } from '../../constants/http';
import {
    API_BRAND,
    API_GET_BRANDS_OF_USER,
    API_GET_BRAND_URL,
    API_UPDATE_BRAND_ONBOARDING_STATUS,
} from '../../constants/api';

export const brandApiSlice = baseApiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            updateBrandOnBoardingStatus: builder.mutation<any, number>({
                query: (brandId) => {
                    return {
                        url: `${API_UPDATE_BRAND_ONBOARDING_STATUS}/?brandId=${brandId}`,
                        method: HTTP_METHODS.PATCH,
                    };
                },
                transformResponse: (data: { result: any }) => data?.result,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            getBrandUrl: builder.query<any, number>({
                query(brandId) {
                    return {
                        url: `${API_GET_BRAND_URL}/?brandId=${brandId}`,
                        method: HTTP_METHODS.GET,
                    };
                },
                transformResponse: ({ data }: any) => data,
                transformErrorResponse: (response) => response,
            }),
            getBrandById: builder.query<any, number>({
                query(id) {
                    return {
                        url: `${API_BRAND}/${id}`,
                        method: HTTP_METHODS.GET,
                    };
                },
                transformResponse: ({ data }: any) => data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            getBrandOfUser: builder.query<any, void>({
                query: () => ({
                    url: `${API_GET_BRANDS_OF_USER}`,
                    method: HTTP_METHODS.GET,
                }),
                providesTags: ['userBrands'],
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response) => response,
            }),
        };
    },
});

export const {
    useUpdateBrandOnBoardingStatusMutation,
    useLazyGetBrandUrlQuery,
    useLazyGetBrandByIdQuery,
    useLazyGetBrandOfUserQuery,
} = brandApiSlice;
